<div class="container">
  <div
    #loadingOverlay
    class="loading-overlay"
    *ngIf="(pharmacyDetails$ | async)?.pending"
  >
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>

  <section class="form-container" [formGroup]="form">
    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label [for]="npiInput" text="Search by Pharmacy NPI">
        </kendo-label>
        <kendo-textbox
          #npiInput
          class="form-field"
          formControlName="npi"
          (keydown.Enter)="getPharmacyDetails()"
          (keydown.Tab)="getPharmacyDetails()"
        >
        </kendo-textbox>
      </kendo-formfield>
    </div>
    <div class="control-wrap search-btn">
      <button
        kendoButton
        [primary]="true"
        [disabled]="!!(pharmacyDetails$ | async)?.pending"
        (click)="getPharmacyDetails()"
      >
        <span class="k-icon k-font-icon k-i-search"></span>
        Search
      </button>
      <p *ngIf="lastSearchDate" class="search-date">
        Last searched {{ lastSearchDate | date: dateTimeFormat }}
      </p>
    </div>
  </section>

  <ng-container *ngIf="searchSubmitted">
    <ng-container *ngIf="pharmacyDetails$ | async as details">
      <div class="no-data-container" [class.container-hidden]="details.data">
        No pharmacy data
      </div>

      <div [class.container-hidden]="!details.data">
        <section class="details-container">
          <div class="detail-field span-4">
            <kendo-label class="detail-field__label" text="Name"> </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ details.data?.pharmacyDetails?.name }}</span>
            </div>
          </div>

          <div class="detail-field span-4">
            <kendo-label class="detail-field__label" text="Taxonomy">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{
                details.data?.pharmacyDetails?.taxonomy?.join(', ')
              }}</span>
            </div>
          </div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="Address Line 1">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{
                details.data?.pharmacyDetails?.address?.address_line_1
              }}</span>
            </div>
          </div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="Address Line 2">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{
                details.data?.pharmacyDetails?.address?.address_line_2
              }}</span>
            </div>
          </div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="City"> </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ details.data?.pharmacyDetails?.address?.city }}</span>
            </div>
          </div>

          <div class="detail-field">
            <kendo-label class="detail-field__label" text="State">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ details.data?.pharmacyDetails?.address?.state }}</span>
            </div>
          </div>

          <div class="detail-field">
            <kendo-label class="detail-field__label" text="Zipcode">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ details.data?.pharmacyDetails?.address?.zip }}</span>
            </div>
          </div>

          <div class="detail-field">
            <kendo-label class="detail-field__label" text="340B Status">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{
                details.data?.pharmacyDetails?.statusIndicator340B
              }}</span>
            </div>
          </div>

          <div class="detail-field">
            <kendo-label class="detail-field__label" text="340B Status Code">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ details.data?.pharmacyDetails?.statusCode340B }}</span>
            </div>
          </div>

          <div class="detail-field span-6">
            <kendo-label class="detail-field__label" text="340B Indicator">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{
                details.data?.pharmacyDetails?.statusCode340B | indicator340b
              }}</span>
            </div>
          </div>
        </section>

        <section
          class="details-container"
          *ngIf="details.data?.pharmacyDetails?.ncpdpqInfo as ncpdpqInfo"
        >
          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="NCPDP Pharmacy ID">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.ncpdp_pharmacy_id }}</span>
            </div>
          </div>

          <div class="detail-field span-6">
            <kendo-label
              class="detail-field__label"
              text="NCPDPQ Pharmacy Name(s)"
            >
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.ncpdpq_pharmacy_name?.join(', ') }}</span>
            </div>
          </div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="Address Line 1">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.address_original?.address_line_1 }}</span>
            </div>
          </div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="Address Line 2">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.address_original?.address_line_2 }}</span>
            </div>
          </div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="City"> </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.address_original?.city }}</span>
            </div>
          </div>

          <div class="detail-field">
            <kendo-label class="detail-field__label" text="State">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.address_original?.state }}</span>
            </div>
          </div>

          <div class="detail-field">
            <kendo-label class="detail-field__label" text="Zipcode">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.address_original?.zip }}</span>
            </div>
          </div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="Store Number">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.store_number }}</span>
            </div>
          </div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="Store Open Date">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.store_open_date }}</span>
            </div>
          </div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="Store Closure Date">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.store_closure_date }}</span>
            </div>
          </div>

          <div class="detail-field span-2"></div>

          <div class="detail-field span-2">
            <kendo-label class="detail-field__label" text="Dispenser Class">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.dispenser_class }}</span>
            </div>
          </div>

          <div class="detail-field span-6">
            <kendo-label class="detail-field__label" text="Provider Type(s)">
            </kendo-label>
            <div class="detail-field__textbox">
              <span>{{ ncpdpqInfo.provider_type?.join(', ') }}</span>
            </div>
          </div>
        </section>

        <section class="mappings-container">
          <div class="table-container">
            <kendo-grid
              class="mappings-table"
              [kendoGridBinding]="details.data?.hrsaPharmacyMapping ?? []"
              [loading]="details.pending"
              [pageable]="false"
              [sortable]="true"
              [filterable]="false"
              (add)="addContractPharmacy()"
              (remove)="removeContractPharmacy($event)"
            >
              <ng-template kendoGridToolbarTemplate>
                <div class="toolbar-container">
                  <div class="toolbar-container__left">
                    <span class="table-title">HRSA Pharmacies</span>
                  </div>
                  <div class="toolbar-container__right">
                    <ng-container *appRole="editRoles">
                      <button
                        kendoGridAddCommand
                        [disabled]="!details.data || details.pending"
                      >
                        Link HRSA Pharmacy
                      </button>
                    </ng-container>
                  </div>
                </div>
              </ng-template>

              <kendo-grid-column field="name" title="Name">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <app-link-or-text
                    [url]="dataItem.link"
                    [text]="dataItem.name"
                    [isExternal]="true"
                    [roleData]="externalLinkRoles"
                  >
                  </app-link-or-text>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                field="address.full_address"
                title="Address"
              ></kendo-grid-column>

              <kendo-grid-command-column
                class="k-text-center"
                [width]="85"
                *appRole="editRoles"
              >
                <ng-template kendoGridCellTemplate let-dataItem>
                  <button kendoGridRemoveCommand>Unlink</button>
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid>
          </div>

          <div class="table-container">
            <kendo-grid
              class="mappings-table"
              [kendoGridBinding]="details.data?.inHousePharmacyMapping ?? []"
              [loading]="details.pending"
              [pageable]="false"
              [sortable]="true"
              [filterable]="false"
              (add)="addInhousePharmacy()"
              (remove)="removeInhousePharmacy($event)"
            >
              <ng-template kendoGridToolbarTemplate>
                <div class="toolbar-container">
                  <div class="toolbar-container__left">
                    <span class="table-title">In-House Pharmacies</span>
                  </div>
                  <div class="toolbar-container__right">
                    <ng-container *appRole="editRoles">
                      <button
                        kendoGridAddCommand
                        [disabled]="!details.data || details.pending"
                      >
                        Link In-House Pharmacy
                      </button>
                    </ng-container>
                  </div>
                </div>
              </ng-template>

              <kendo-grid-column field="name" title="Name">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <app-link-or-text
                    [url]="dataItem.link"
                    [text]="dataItem.name"
                    [isExternal]="true"
                    [roleData]="externalLinkRoles"
                  >
                  </app-link-or-text>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                field="id340b"
                title="340B ID"
              ></kendo-grid-column>

              <kendo-grid-command-column
                class="k-text-center"
                [width]="85"
                *appRole="editRoles"
              >
                <ng-template kendoGridCellTemplate let-dataItem>
                  <button kendoGridRemoveCommand>Unlink</button>
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid>
          </div>
        </section>
      </div>
    </ng-container>
  </ng-container>
</div>
